///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

import { Component, OnDestroy, OnInit } from '@angular/core';
import { GtthExportService } from '../../../services/project/export.service';
import { GtthHistoryService } from '../../logical-topology/engine/history-service';
import { GtthTunnelsService } from '../../project-windows/reports/tunnels/tunnels.service';
import { GtthLogicalTopology } from '../../logical-topology/entities/logical-topology';
import { AutoDesignPtMpModel } from '../../../services/logical-topology/design/auto-design-ptmp.model';
import { Subscription } from 'rxjs';
import { GtthProjectStateService } from '../../logical-topology/engine/project-state.service';

type TunnelsState = 'show' | 'hide';

@Component({
    selector: 'winde-step-reports',
    templateUrl: './step-reports.component.html',
    styleUrls: ['./reports.scss', '../steps-toolbar.scss'],
    standalone: false
})
export class GtthStepReportsComponent implements OnInit, OnDestroy {
    public showTunnels = false;

    private tunnels: Subscription;

    constructor(
        private readonly exportService: GtthExportService,
        public readonly historyService: GtthHistoryService,
        public readonly tunnelsService: GtthTunnelsService,
        public readonly projectStateService: GtthProjectStateService
    ) {}

    ngOnInit(): void {
        this.historyService.logicalTopology.designStateChanged().subscribe((isShowDesign) => {
            const tunnelsState = isShowDesign ? 'show' : 'hide';
            this.changeTunnelsState(tunnelsState);
        });
    }

    ngOnDestroy(): void {
        this.clearTunnels();
    }

    isShowTunnels(): boolean {
        if (this.historyService.logicalTopology.autodesignP2mpPerLayer[0] instanceof AutoDesignPtMpModel) {
            // do not remove this check, it prevents crash while project dialog is saving
            if (
                this.historyService.logicalTopology.layersModeEnabled &&
                this.historyService.logicalTopology.activeLayerIdx === GtthLogicalTopology.WHOLE_TOPOLOGY_LAYER_INDEX
            ) {
                return this.historyService.logicalTopology.autodesignP2mpPerLayer?.some((autodesignP2mpPerLayer: AutoDesignPtMpModel) =>
                    autodesignP2mpPerLayer.isResiliencyEnabled()
                );
            } else {
                return this.historyService.logicalTopology.autodesignP2mpPerLayer[
                    this.historyService.logicalTopology.activeLayerIdx
                ]?.isResiliencyEnabled();
            }
        }
        return true;
    }

    projectHasMhTgBu(): boolean {
        return this.historyService.logicalTopology.selectedProductsContainsMhTgBu(this.historyService.projectProductsService);
    }

    exportAllReports() {
        this.exportService.exportAllReports(this.historyService.projectInfoViewService.activeLayer);
    }

    private changeTunnelsState(tunnelsState: TunnelsState): void {
        if (tunnelsState === 'show') {
            this.showTunnelsAfterDesign();
        } else {
            this.clearTunnels();
        }
    }

    private showTunnelsAfterDesign() {
        this.showTunnels = this.isShowTunnels();
        if (this.showTunnels) {
            this.tunnels = this.tunnelsService.getTunnelsWithTypes().subscribe();
        }
    }

    private clearTunnels(): void {
        if (this.tunnels) {
            this.tunnels.unsubscribe();
            this.tunnelsService.clearTunnels();
        }
    }
}
